import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getConsent } from '../lib/consent';

function PageTracker() {
  const location = useLocation();

  useEffect(() => {
    if (getConsent() !== 'accepted') return;

    const params = new URLSearchParams(location.search);
    fetch('/api/track/pageview', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        consent: true,
        path: location.pathname,
        referrer: document.referrer || '',
        utmSource: params.get('utm_source') || '',
        utmMedium: params.get('utm_medium') || '',
        utmCampaign: params.get('utm_campaign') || ''
      }),
      keepalive: true
    }).catch(() => {});
  }, [location.pathname, location.search]);

  return null;
}

export default PageTracker;
